import React, { useContext, useState, useEffect } from 'react';
import { Row, Col, Input, Table, Container, Card, CardBody } from 'reactstrap'
import { useParams, useHistory } from 'react-router-dom';
import Dropzone from 'react-dropzone-uploader';
import AsyncSelect from 'react-select/async';
import { toast } from 'react-toastify'
import {
  Plus, Trash2, Upload, Download, Layers, Link as LinkIcon, FileText, Send
} from 'react-feather';

import { Formik, Form, Field, ErrorMessage, FieldArray,  setNestedObjectValues } from 'formik';
import axios from 'axios'
import XLSX from 'xlsx'
import * as Yup from 'yup';

import { getItem } from '../../../localStorageMethods';
import Breadcrumbs from '../../Common/BreadCrumb/BreadCrumbs.component';

// custom hooks
import useOrgIdentifer from '@hooks/org_identifier';

export default function AddNewSitesToSiteGroupFormik({current_user, current_organization, take_my_org_details}) {

  let accessEnv = ['staging']
  const history = useHistory()
  const environment = getItem('environment')
  const [sitegroupNamesDropdownOptions, setSitegroupNamesDropdownOptions] = useState([])

  const org_identifier = useOrgIdentifer();

  useEffect(() => {
    take_my_org_details(org_identifier);
  }, [org_identifier]);

  useEffect(() => {
    if (org_identifier == "promptcloud"){
      history.push('/');
      toast.error("You are not authorized this page")
    } 
  }, [org_identifier])

  useEffect(() => {
    axios.get(`/api/v1/organizations/${org_identifier}/sitegroups?from=new_sites_form`).then(res => {
        setSitegroupNamesDropdownOptions(convertToArrayOfObjects(res?.data?.sitegroups));
    }).catch(err => {
        // Refactor later
        if (err?.response?.data?.page_auth_failed) {
          history.push("/")
          toast.error(err?.response?.data?.message)
        }
        else if (!err?.response?.data?.org_auth_failed){
          toast.error(err?.response?.data?.message)
        }
    })
  }, [org_identifier])

 
  // Helper function to convert array of arrays into
  // Array of objects
  function convertToArrayOfObjects(inputArray) {
    return inputArray.map(([value, label]) => ({ value, label }));
  }

  // Helper function to filter the values and return the object
  // based on user input
  const filterValues = (inputValue) => {
      return sitegroupNamesDropdownOptions.filter((i) =>
      i.label.toLowerCase().includes(inputValue.toLowerCase())
      );
  };

  // AsyncMethod to traverse the array and return resut that matches 
  // the input query entered by the user 
  const loadOptions = (inputValue, callback) => {
      setTimeout(() => {
      callback(filterValues(inputValue));
      }, 650);
  };

  const getUploadParams = ({ meta }) => { return { url: 'https://httpbin.org/post' } }

  Yup.addMethod(Yup.object, 'unique', function (propertyName, message) {
    return this.test('unique', message, function (value) {
      if (!value || !value[propertyName]) {
        return true;
      }

      const { path } = this;
      const options = [...this.parent];
      const currentIndex = options.indexOf(value);

      const subOptions = options.slice(0, currentIndex);

      if (subOptions.some((option) => option[propertyName] === value[propertyName])) {
        throw this.createError({
          path: `${path}.${propertyName}`,
          message,
        });
      }

      return true;
    });
  });

  const handleChangeStatus = (uploadData, status, form) => {
    const { setFieldValue, validateForm, setTouched, values, setFieldTouched, setFieldError } = form
    const { meta, file } = uploadData
    if (status === "done") {
      var fileReader = new FileReader();
      fileReader.onload = function (event) {
        var workbook = XLSX.read(event.target.result, {
          type: "binary"
        });
        workbook.SheetNames.forEach(sheet => {
          let rowObject = XLSX.utils.sheet_to_row_object_array(
            workbook.Sheets[sheet]
          );
          let headerCondition;
          if (accessEnv.includes(environment)) {
            headerCondition = ("page_url" in rowObject[0] && "rss_urls_crawl_limit" in rowObject[0])
          }
          else {
            headerCondition = ("page_url" in rowObject[0])
          }
          if (rowObject.length === 0) {
            toast.error("Uploaded file is empty")
          }
          else if (headerCondition) {
            let newRows = values
            .filter(item => item?.url?.length > 0 || String(item?.rss_urls_crawl_limit).length > 0)
            .map(item => ({
              url: item.url || "",
              rss_urls_crawl_limit: item.rss_urls_crawl_limit || ""
            }));
            rowObject.forEach(item => {
              newRows.push({
                url: item?.page_url || "",
                rss_urls_crawl_limit: accessEnv.includes(environment) ? item?.rss_urls_crawl_limit || "" : ""
              });
            });
            setFieldValue("site_details",newRows,true).then(()=>{
              validateForm({ site_details: newRows})
              .then(errors => {
                setTouched(setNestedObjectValues(errors, true))
                if(!checkForValues(newRows)){
                  toast.error("please enter atleast one feasible url")
                } else if (Object.keys(errors).length === 0) {
                  return
                } else {
                  setTouched(setNestedObjectValues(errors, true))
                  toast.error("The form is invalid so please check it!")
                }
              })
              .catch(error => console.log(error));
            })
          }
          else {
            toast.error("Please keep column headers as mentioned in sample excel file")
          }
        });
      };
      fileReader.readAsBinaryString(file);
    }
    else if (status === "removed") {
      let empty_rows = [
        {url:"", rss_urls_crawl_limit:""},
        {url:"", rss_urls_crawl_limit:""},
        {url:"", rss_urls_crawl_limit:""},
        {url:"", rss_urls_crawl_limit:""},
      ]
      setFieldValue("site_details",empty_rows)
      setFieldTouched("site_details", false)
      setFieldError("site_details",[])
    }
    else if (status === 'rejected_file_type') {
      toast.error("ERROR: Unsupported File Format!" + "\n" + "Supported file formats are .xls, .xlsx, .xlsb, .xlsm, .ods, .ots, .uos");
    }
  }

  const handleExcelDownload = () => {
    axios.defaults.headers["Authorization"] = `Bearer ${localStorage.getItem("authToken")}`;
    axios.defaults.headers["Content-Type"] = `application/vnd.ms-excel`;
    axios.defaults.headers["Accept"] = `application/vnd.ms-excel`;
    axios({
        url: `/api/v1/download_sample_site_details`,
        method: 'GET',
        responseType: 'blob'
    })
        .then((res) => {
            const url_to_download = window.URL.createObjectURL(new Blob([res.data]));
            const a_tag = document.createElement('a');
            a_tag.href = url_to_download;
            a_tag.setAttribute('download', `sample_site_urls.xls`);
            document.body.appendChild(a_tag);
            a_tag.click();
        });
    axios.defaults.headers["Content-Type"] = `application/json`;
    axios.defaults.headers["Accept"] = `application/json`;
  }

  const handleSubmit = (files, allFiles) => {
    allFiles.forEach(f => f.remove())
    toast.success("Dropzone successfully submitted !");
  }

  const checkForValues = (details) => {
    let feasible = false
    var url = new RegExp(/^((www\.)|(http(s*)))/i);
    var rss_urls = accessEnv.includes(environment) ? new RegExp(/^\d+$/) : new RegExp(/.*/)
    details?.map(obj => {
      if(accessEnv.includes(environment)){
        if(url.test(obj?.url) && rss_urls.test(obj?.rss_urls_crawl_limit)) feasible = true
      } else {
        if(url.test(obj?.url)) feasible = true
      } 
    })
    return feasible
  }

  const validationSchema = Yup.object({
    sitegroup_id: Yup.string().strip(),
    site_details : Yup.array().of(
      Yup.object().shape({
        url: Yup.string().when("rss_urls_crawl_limit", {
          is: (rss_urls_crawl_limit) => rss_urls_crawl_limit?.length > 0 && accessEnv.includes(environment),
          then: () => Yup.string()
            .required("This field is required if rss urls crawl limit has value!")
            .min(1, "This field is required if rss urls crawl limit has value!")
            .matches(/^((www\.)|(http(s*):\/\/))/i, "Please enter a valid URL"),
          otherwise: () => Yup.string().matches(/^((www\.)|(http(s*):\/\/))/i, { message: "Please enter a valid URL", excludeEmptyString: true }),
        }),
        rss_urls_crawl_limit: Yup.string().when("url", {
          is: (url) => url?.length > 0 && accessEnv.includes(environment),
          then: () => Yup.string()
            .required('This field is required if url has value!')
            .min(1, 'This field is required if url has value!')
            .matches(/^\d+$/, "This field should be integer!"),
          otherwise: () => Yup.string(),
        })
      }, ['rss_urls_crawl_limit', 'url']).unique("url", "Entered URL is already present")
    )
  })

  const validationSchemaForUrls = Yup.array().of(
    Yup.lazy((values) => {

      const isUrlPresent = values.url && values.url.trim().length > 0;

      return Yup.object().shape({
        url: isUrlPresent
          ? Yup.string()
              .test('is-feasible', 'This URL is not feasible', async function (value) {
                const { path } = this;

                if (/^((www\.)|(http(s*):\/\/))/i.test(value?.trim())) {
                  const url = value?.trim();

                  try {
                    const response = await axios.post('/api/v1/sites/check_feasibility', {
                      sites: { sample_page_url: url },
                    });

                    if (response.data.status !== 'success') {
                      return this.createError({
                        path: `${path}`,
                        message: 'This URL is not feasible',
                      });
                    }
                  } catch (error) {
                    console.error("API call failed:", error);
                    return this.createError({
                      path: `${path}`,
                      message: 'This URL is not feasible',
                    });
                  }
                }
                return true;
              })
          : Yup.string(),
        rss_urls_crawl_limit: Yup.string(),
      });
    })
  )

  const addSitetoSitegroup = (values, form) => {
    const { setTouched, validateForm, setErrors, setSubmitting, setFieldValue} = form
    validateForm().then( async errors => {
      setTouched(setNestedObjectValues(errors, true));
      if(errors?.site_details?.length > 0){
        toast.error("Please fill in the required fields")
      }else if(!checkForValues(values?.site_details)) {
        toast.error("Please enter at least one feasible URL.");
      } else if (typeof values?.sitegroup_id === 'string' || typeof values?.sitegroup_id?.value != 'number') {
        toast.error(`Sitegroup is not present or does not belong to organization ${org_identifier}.`);
      } else {
        try {
          await validationSchemaForUrls.validate(values?.site_details, { abortEarly: false });
          setSubmitting(false)
          let new_urls = []
          const rss_urls = accessEnv.includes(environment) ? new RegExp(/^\d+$/) : new RegExp(/.*/)
          new_urls = values?.site_details.filter((site) => site?.url?.length > 0 && rss_urls.test(site?.rss_urls_crawl_limit))

          axios.post(`/api/v1/organizations/${org_identifier}/sites`, {
            submit_requirements: {
              sitegroup_id: values?.sitegroup_id?.value,
              site_add_from: "client_side",
              site_details: new_urls
            }
          }).then(res => {
            toast.success(res.data.message);
            history.push(`/organizations/${org_identifier}/sites`);
          }).catch(err => {
            toast.error(err?.response?.data?.message);
          })

        } catch (validationErrors) {
          const errorIndices = validationErrors.inner.map((error) => {
            const match = error.path.match(/\[(\d+)\]/);
            return match ? parseInt(match[1], 10) : -1;
          }).filter((index) => index !== -1);
    
          let formattedErrors = Array(values.site_details.length).fill({ url: '', rss_urls_crawl_limit: '' });
          errorIndices.forEach((index) => {
            formattedErrors[index] = {
              url: 'This URL is not feasible',
              rss_urls_crawl_limit: formattedErrors[index].rss_urls_crawl_limit,
            }
          })
          setErrors({ site_details: formattedErrors });
          setTouched(setNestedObjectValues({ site_details: formattedErrors }, true), false);
          toast.error('The form is invalid. Please check it!');
          setSubmitting(false);
        }
      }
    }).catch(error => {
      console.log('error', error)
    })
  }


  const labelStyle = {
    fontSize: 11,
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '0.04em',
    color: '#6c757d',
  };

  return (
    <Container fluid>
      <Breadcrumbs
        parent={'Add Sites To Site Group'}
        title={'Add Sites To Site Group'}
        childrenObj={[{ name: 'Sites', url: `/organizations/${org_identifier}/sites` }]}
      />

      {/* Page header */}
      <Card className='shadow-sm border-0 mb-3'>
        <CardBody className='d-flex align-items-start' style={{ padding: '20px 24px', gap: 14 }}>
          <div
            className='d-inline-flex align-items-center justify-content-center flex-shrink-0'
            style={{ width: 44, height: 44, borderRadius: 10, background: '#0d6efd15', color: '#0d6efd' }}
          >
            <Plus size={22} />
          </div>
          <div style={{ minWidth: 0 }}>
            <h5 className='mb-1 text-dark fw-semibold' style={{ fontSize: 18 }}>
              Add Sites to a Site Group
            </h5>
            <p className='text-muted mb-0' style={{ fontSize: 13 }}>
              Pick the destination site group, then either paste URLs row-by-row or upload an Excel file.
            </p>
          </div>
        </CardBody>
      </Card>

      <Formik
        initialValues={{
          sitegroup_id: '',
          site_details: [
            { url: '', rss_urls_crawl_limit: '' },
            { url: '', rss_urls_crawl_limit: '' },
            { url: '', rss_urls_crawl_limit: '' },
            { url: '', rss_urls_crawl_limit: '' },
          ],
        }}
        validateOnChange={false}
        validateOnBlur={true}
        validationSchema={validationSchema}
      >
        {({ isSubmitting, values, setFieldValue, validateForm, setTouched, errors, setErrors, setSubmitting, setFieldTouched, setFieldError }) => {
          return (
            <Form>
              {/* Step 1: Site group selector */}
              <Card className='shadow-sm border-0 mb-3'>
                <CardBody style={{ padding: 24 }}>
                  <div className='d-flex align-items-start mb-3'>
                    <div
                      className='d-inline-flex align-items-center justify-content-center me-3 flex-shrink-0'
                      style={{ width: 32, height: 32, borderRadius: 8, background: '#0d6efd15', color: '#0d6efd', fontWeight: 700 }}
                    >
                      <Layers size={16} />
                    </div>
                    <div>
                      <h6 className='fw-semibold mb-1 text-dark' style={{ fontSize: 15 }}>
                        Step 1 — Select a site group
                      </h6>
                      <p className='text-muted mb-0' style={{ fontSize: 13 }}>
                        New sites will inherit this group's schema and delivery settings.
                      </p>
                    </div>
                  </div>
                  <label className='d-block mb-1' style={labelStyle}>Site Group</label>
                  <Field
                    name='sitegroup_id'
                    component={AsyncSelect}
                    className='select_sitegroup'
                    placeholder='Select a site group…'
                    cacheOptions
                    defaultOptions={sitegroupNamesDropdownOptions}
                    onChange={(option) => setFieldValue('sitegroup_id', option)}
                    loadOptions={loadOptions}
                  />
                  <ErrorMessage name='sitegroup_id' component='p' className='m-0 error-msg mt-1 mb-0' />
                </CardBody>
              </Card>

              {/* Step 2: URL entry */}
              <Card className='shadow-sm border-0 mb-3'>
                <CardBody style={{ padding: 24 }}>
                  <div className='d-flex align-items-start mb-3'>
                    <div
                      className='d-inline-flex align-items-center justify-content-center me-3 flex-shrink-0'
                      style={{ width: 32, height: 32, borderRadius: 8, background: '#19875415', color: '#198754' }}
                    >
                      <LinkIcon size={16} />
                    </div>
                    <div>
                      <h6 className='fw-semibold mb-1 text-dark' style={{ fontSize: 15 }}>
                        Step 2 — Enter URLs
                      </h6>
                      <p className='text-muted mb-0' style={{ fontSize: 13 }}>
                        One URL per row. Empty rows are ignored on submit.
                      </p>
                    </div>
                  </div>

                  <FieldArray name='site_details' validateOnChange={true}>
                    {({ push, remove, form }) => {
                      const { values } = form;
                      const { site_details } = values;
                      const showRss = accessEnv.includes(environment);

                      return (
                        <>
                          <Table hover className='site-details-table align-middle mb-3' style={{ fontSize: 13 }}>
                            <thead>
                              <tr style={{ borderBottom: '1px solid #e9ecef' }}>
                                <th style={{ ...labelStyle, width: 56, paddingTop: 6, paddingBottom: 6 }}>#</th>
                                <th style={{ ...labelStyle, paddingTop: 6, paddingBottom: 6 }}>URL</th>
                                {showRss && (
                                  <th style={{ ...labelStyle, width: 220, paddingTop: 6, paddingBottom: 6 }}>
                                    RSS Crawl Limit
                                  </th>
                                )}
                                <th style={{ width: 56 }} />
                              </tr>
                            </thead>
                            <tbody>
                              {site_details.map((row, index) => (
                                <tr key={index}>
                                  <td className='text-muted' style={{ verticalAlign: 'top', paddingTop: 12 }}>
                                    {index + 1}
                                  </td>
                                  <td style={{ width: showRss ? '60%' : 'auto' }}>
                                    <Field
                                      name={`site_details[${index}].url`}
                                      className='form-control form-control-sm'
                                      type='text'
                                      placeholder='https://www.example.com/category-page'
                                    />
                                    <ErrorMessage
                                      name={`site_details[${index}].url`}
                                      component='p'
                                      className='m-0 error-msg mt-1 mb-0'
                                    />
                                  </td>
                                  {showRss && (
                                    <td>
                                      <Field
                                        name={`site_details[${index}].rss_urls_crawl_limit`}
                                        className='form-control form-control-sm'
                                        type='text'
                                        placeholder='30000 (default)'
                                      />
                                      <ErrorMessage
                                        name={`site_details[${index}].rss_urls_crawl_limit`}
                                        component='p'
                                        className='m-0 error-msg mt-1 mb-0'
                                      />
                                    </td>
                                  )}
                                  <td style={{ verticalAlign: 'top', paddingTop: 8 }}>
                                    {site_details.length > 1 && (
                                      <button
                                        type='button'
                                        className='btn btn-sm btn-link text-muted p-1'
                                        onClick={() => remove(index)}
                                        title='Remove row'
                                      >
                                        <Trash2 size={14} />
                                      </button>
                                    )}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>

                          <button
                            className='btn btn-outline-primary btn-sm d-inline-flex align-items-center'
                            type='button'
                            onClick={() => push({ url: '', rss_urls_crawl_limit: '' })}
                          >
                            <Plus size={14} className='me-1' /> Add another row
                          </button>

                          {/* OR divider */}
                          <div className='d-flex align-items-center my-4' style={{ gap: 12 }}>
                            <div style={{ flex: 1, borderTop: '1px solid #e9ecef' }} />
                            <span
                              className='text-muted'
                              style={{ fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.04em' }}
                            >
                              Or
                            </span>
                            <div style={{ flex: 1, borderTop: '1px solid #e9ecef' }} />
                          </div>

                          {/* File upload */}
                          <div className='d-flex align-items-start mb-2'>
                            <div
                              className='d-inline-flex align-items-center justify-content-center me-3 flex-shrink-0'
                              style={{ width: 32, height: 32, borderRadius: 8, background: '#fd7e1415', color: '#fd7e14' }}
                            >
                              <Upload size={16} />
                            </div>
                            <div>
                              <h6 className='fw-semibold mb-1 text-dark' style={{ fontSize: 14 }}>
                                Bulk upload via Excel
                              </h6>
                              <p className='text-muted mb-0' style={{ fontSize: 12 }}>
                                Upload many sites at once. Adds to whatever rows you've entered above.
                              </p>
                            </div>
                          </div>

                          <Row className='align-items-start g-3 mt-1'>
                            <Col md={8}>
                              <Dropzone
                                getUploadParams={getUploadParams}
                                maxFiles={1}
                                onChangeStatus={(uploadData, status) =>
                                  handleChangeStatus(uploadData, status, {
                                    setFieldError,
                                    setFieldValue,
                                    setTouched,
                                    validateForm,
                                    setFieldTouched,
                                    values: values?.site_details,
                                  })
                                }
                                multiple={false}
                                canCancel={true}
                                accept='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,application/vnd.ms-excel.sheet.binary.macroEnabled.12,application/vnd.oasis.opendocument.spreadsheet,application/vnd.ms-excel.sheet.macroEnabled.12,application/vnd.oasis.opendocument.spreadsheet-template'
                                inputContent={(files, extra) =>
                                  extra.reject ? 'Please enter only supported files' : 'Upload or drop an Excel file'
                                }
                                styles={{
                                  dropzone: {
                                    minHeight: 80,
                                    border: '2px dashed #ced4da',
                                    borderRadius: 8,
                                    background: '#f8f9fa',
                                  },
                                  dropzoneActive: { borderColor: '#0d6efd', background: '#e7f1ff' },
                                  inputLabel: { fontSize: 13, color: '#495057' },
                                }}
                              />
                              <p className='text-muted m-0 mt-2' style={{ fontSize: 12 }}>
                                Supported formats: .xls, .xlsx, .xlsb, .xlsm, .ods, .ots, .uos
                              </p>
                            </Col>
                            <Col md={4}>
                              <button
                                type='button'
                                onClick={handleExcelDownload}
                                className='btn btn-outline-secondary btn-sm w-100 d-inline-flex align-items-center justify-content-center'
                              >
                                <Download size={14} className='me-2' /> Download sample Excel
                              </button>
                              <p className='text-muted mb-0 mt-2' style={{ fontSize: 12 }}>
                                Don't change the column headers in the sample file.
                              </p>
                            </Col>
                          </Row>
                        </>
                      );
                    }}
                  </FieldArray>
                </CardBody>
              </Card>

              {/* Footer */}
              <div className='d-flex justify-content-end mb-4' style={{ gap: 8 }}>
                <button
                  type='button'
                  className='btn btn-outline-secondary'
                  onClick={() => history.push(`/organizations/${org_identifier}/sites`)}
                >
                  Cancel
                </button>
                <button
                  type='button'
                  className='btn btn-primary d-inline-flex align-items-center'
                  onClick={() => addSitetoSitegroup(values, { validateForm, setTouched, setErrors, setSubmitting })}
                  disabled={isSubmitting}
                >
                  <Send size={14} className='me-2' />
                  {isSubmitting ? 'Adding sites…' : 'Add sites'}
                </button>
              </div>
            </Form>
          );
        }}
      </Formik>
    </Container>
  );
}
